import { GET_DEVICE_LISTS } from '../graphql/query/deviveList';
import { client } from './apolloClient';

export type IDevice = {
    id: number;
    device_id: string;
};
export type IUserData = {
    id: number;
    first_name: string;
    last_name: string;
    profile_image: string;
    status: number;
};
export type IDeviceResponse = {
    [key: string]: IUserData[];
};

export type IDeviceData = {
    deviceList: IDevice[];
    deviceData: IDeviceResponse;
};

export const fetchDeviceList = async (): Promise<any | null> => {
    try {
        let deviceList: IDevice[] = [];
        let deviceData = null;
        const { data } = await client.query({
            query: GET_DEVICE_LISTS,
            fetchPolicy: 'network-only',
        });
        const deviceObj: IDeviceResponse = data?.getUniqueDevicesList;
        if (deviceObj) {
            deviceData = deviceObj;
            const deviceIds = Object.keys(deviceObj);
            deviceList = deviceIds?.map((deviceId: string, index: number) => ({
                id: index,
                device_id: deviceId,
            }));
        }
        return {
            deviceList,
            deviceData,
        };
    } catch (error) {
        console.error('Error fetching device list:', error);
        throw error;
    }
};
